/**
 * Access Denied Page (DC-902)
 *
 * Shown when user doesn't have permission to access a route.
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import '../../styles/auth.css';

export function AccessDenied() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  return (
    <div className="access-denied-page">
      <div className="access-denied-icon">🚫</div>

      <h1 className="access-denied-title">Access Denied</h1>

      <p className="access-denied-message">
        {isAuthenticated
          ? `Sorry, your account (${user?.role}) doesn't have permission to access this page.`
          : 'You need to be signed in to access this page.'}
      </p>

      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
        <button
          onClick={() => navigate(-1)}
          className="auth-button auth-button-secondary"
          style={{ width: 'auto' }}
        >
          Go Back
        </button>

        {isAuthenticated ? (
          <Link
            to="/home"
            className="auth-button"
            style={{ textDecoration: 'none', width: 'auto' }}
          >
            Go to Home
          </Link>
        ) : (
          <Link
            to="/login"
            className="auth-button"
            style={{ textDecoration: 'none', width: 'auto' }}
          >
            Sign In
          </Link>
        )}
      </div>
    </div>
  );
}

export default AccessDenied;
